import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress } from '@material-ui/core';
import ReportingService from 'Lib/API/Report';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { HintField, InputField, LabelField } from 'components';
import InfoTooltip from 'components/InfoTooltip';
import Loader from 'components/loader/Loader';
import { useFormik } from 'formik';
import { SubHeader } from 'layout/SubHeader';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import styled from 'styled-components';
import NotAuthorized from '../../components/NotAuthorized';



import {
  All,
  Favorite,
  Fillter,
  FinancialReports,
  ReportsList,
} from './components';

import MyModal from 'components/MyModal';
import { Route, useHistory, useLocation, useParams } from 'react-router-dom';

// import { Route, useHistory, useLocation } from "react-router-dom";
import AlertDialog from 'components/Dialog/index';
import Button from 'components/button/Button';
import MainTabs from 'components/mainTabs/MainTabs';
import { useDisableEnterKey } from 'hook';
import './index.scss';

const tabOptions = [
  {
    title: "All Reports",
    value: "All Reports",
    width: "200px",
  },
  {
    title: "Favorites",
    value: "Favorites",
    width: "200px",
  },
  {
    title: "Financial Reports",
    value: "Financial Reports",
    width: "200px",
  }
]


const ModalBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff !important;
  height: 1150px;
  width: 988px;

  > h1 {
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
  }

  :nth-child(1) > :nth-child(2) {
    background: #ffffff !important;
    display: flex;
    /* justify-content: center; */
    flex-direction: column;
    /* align-items: center; */
    border-radius: 4px;
    /* width: 841px;
    height: 366px; */
  }
`;
const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #2555ef;
  border-radius: 5px;
  color: #2555ef;
  width: 170px;
  height: 48px;
`;
const TAB_PARAM = 'tab';
const tabValueToParam = (val) => val.toLowerCase().replace(/ /g, '-');
const tabParamToValue = (param) => tabOptions.find(t => tabValueToParam(t.value) === param)?.value ?? 'All Reports';

export const Report = () => {
  const location = useLocation();
  const { push } = useHistory();
  const initialTab = tabParamToValue(new URLSearchParams(location.search).get(TAB_PARAM));
  const [toggle, setToggle] = useState(initialTab);

  useEffect(() => {
    const tabFromUrl = tabParamToValue(new URLSearchParams(location.search).get(TAB_PARAM));
    setToggle(tabFromUrl);
    setPage(0);
  }, [location.search]);
  const { getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [confirmClose, setConfirmClose] = useState(false);

  const [DuolicatetModal, setDuolicatetModal] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isReportActive, setIsReportActive] = useState(true);

  const [duolicatetIsLoading, setDuolicatetIsLoading] = useState(false);
  const [id, setId] = useState(null);
  const [DuolicatetData, setDuolicatetData] = useState({
    filterName: '',
    filterId: '',
  });
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      date: formik?.values?.date,
    },
    validationSchema: '',
    onSubmit: async (values) => { },
  });
  const [fillter, setFilter] = useState({
    search: '',
    filter: {},
  });
  const onSearchChange = (e) => {
    const name = e.target.value;
    setFilter((prev) => ({
      ...prev,
      search: name ? name : undefined,
    }));
  };
  const sortReport = () => {
    setFilter((prev) => ({
      ...prev,
      sort:
        prev?.sort?.name === 1
          ? {
            name: -1,
          }
          : {
            name: 1,
          },
    }));
  };
  // const { push } = useHistory();
  const handleClick = (tab) => {
    setToggle(tab?.value);
    push({ search: `?${TAB_PARAM}=${tabValueToParam(tab?.value)}` });
    if (tab?.value === 'Favorites') {
      setFilter((prev) => ({
        ...prev,
        filter: {
          favourite: true,
        },
      }));
    }
    else {
      setFilter((prev) => ({
        ...prev,
        filter: {},
      }));
    }
  };

  const DuolicatetReport = async () => {
    setDuolicatetIsLoading(true);
    const token = await getAccessTokenSilently();
    ReportingService.duplicate(token, { ...DuolicatetData })
      .then((res) => {
        setDuolicatetIsLoading(false);

        if (res?.message) {
          setError(res?.message);
        } else {
          getReports();
          setDuolicatetModal(false);
          toastr.success('Success', 'Report has been Duolicated');
        }
      })
      .catch((err) => {
        setDuolicatetIsLoading(false);
      });
  };
  useEffect(() => {
    getReports();
  }, [fillter, toggle, page, rowsPerPage]);
  const getReports = async () => {
    setIsloading(true);
    setData([]);

    const body = { ...fillter };
    if (!body.search) delete body.search;
    // Always derive favourite filter from toggle to avoid stale state
    if (toggle === 'Favorites') {
      body.filter = { ...body.filter, favourite: true };
    } else {
      if (body.filter) delete body.filter.favourite;
      if (body.filter && Object.keys(body.filter).length === 0) delete body.filter;
    }

    const token = await getAccessTokenSilently();
    ReportingService.getList(token, page + 1, rowsPerPage, body)
      .then((res) => {
        setData(res?.payload?.data);
        setIsloading(false);
        setCount(res?.payload?.pagination?.count);
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message ?? "Report got error");
        setData([]);
        setIsloading(false);
      });
  };

  let orgInfo = localStorage?.getItem('authorizedModules')
    ? JSON.parse(localStorage?.getItem('authorizedModules'))
    : [];

  // useEffect(() => {
  //   let check =
  //     orgInfo !== undefined ??
  //     JSON.parse(orgInfo)?.map((item) => {
  //       if (item?.moduleName == "report") {
  //         return setIsReportActive(item?.active);
  //       }
  //     });
  // }, []);

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName === 'report' && item?.active === true) {
        // console.log('item:report ');
        return setIsReportActive(item?.active);
      } else {
        return setIsReportActive(false);
      }
    });
    setIsReportActive(orgInfo?.find(item => item?.moduleName === 'report')?.active);

  }, []);

  useDisableEnterKey(true);


  const closeDuplicateModal = () => {
    setConfirmClose(true);
  }

  const confirmCloseModal = () => {
    setConfirmClose(false);
    setDuolicatetModal(false);
  }



  return !isReportActive ? (
    <NotAuthorized title={'Segments'} />
  ) : (
    <div className="members pr-3 pr-sm-12 pt-5">
      <>
        <div className="report__header d-flex justify-content-between align-items-center mt-5">
          <div className="d-flex align-items-center">
            <SubHeader
              className="subheader"
              {...{
                title: 'Segments',
                color: '#2455EF',
              }}
            />
            <InfoTooltip text="Segments let you filter members by criteria, choose which fields to show, and save the result to reuse for reports, mailing labels, or bulk tagging." placement="right" style={{ marginLeft: '8px', position: 'relative', top: '-3px' }} />
          </div>
          {toggle !== "Financial Reports" && (
            <Button
              className="mx-2"
              variant="primary"
              onClick={() => {
                push({
                  pathname: `/create-new-filter/`,
                });
              }}
            >
              <PlusIcon />
              <span>New Segment</span>
            </Button>
          )}
        </div>
        <MainTabs
          className={'mt-10'}
          tabs={tabOptions}
          activeTab={toggle}
          onTabsChange={(tab) => {
            handleClick(tab);
            setPage(0);
          }}
        />
        {/* <div
          className="toggle-bar mt-10"
          style={{
            borderBottom: '1px solid #E7E7EB',
          }}
 
        >
          {tabOptions.map((tab, i) => (
            <span
              style={{ width: '240px' }}
              className={
                toggle === tab
                  ? 'selected tab-title w-220px '
                  : 'unselected tab-title w-220px'
              }
              onClick={() => {
                handleClick(tab);
                setPage(0);
              }}
            >
              {tab?.toLowerCase() ===  "all reports" ? "Segments" : tab}
            </span>
          ))}
        </div> */}
      </>
      {toggle === 'Favorites' ? (
        <Favorite
          fillter={fillter}
          onSearchChange={onSearchChange}
          sortReport={sortReport}
          setDuolicatetModal={setDuolicatetModal}
          setDuolicatetData={setDuolicatetData}
          getReports={getReports}
          setPage={setPage}
          count={count}
          page={page}
          data={data}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setId={setId}
          selectedId={id}
        />
      ) : toggle == 'Financial Reports' ? (
        <FinancialReports
          fillter={fillter}
          onSearchChange={onSearchChange}
          sortReport={sortReport}
          setDuolicatetModal={setDuolicatetModal}
          setDuolicatetData={setDuolicatetData}
          getReports={getReports}
          setPage={setPage}
          count={count}
          page={page}
          data={data}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setId={setId}
          selectedId={id}
          toggle={toggle}
        />
      ) : (
        <All
          fillter={fillter}
          onSearchChange={onSearchChange}
          sortReport={sortReport}
          setDuolicatetModal={setDuolicatetModal}
          setDuolicatetData={setDuolicatetData}
          getReports={getReports}
          setPage={setPage}
          count={count}
          page={page}
          data={data}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setId={setId}
          selectedId={id}
        />
      )}
      <MyModal
        className={'new-charge-modal-pendding new-charge-modal'}
        open={DuolicatetModal}
        onClose={closeDuplicateModal}
      >
        <ModalBox className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
          <h1 className="pb-5 pt-8">Duplicate Segment</h1>
          <div className="col-mb-11 col-xs-11 col-lg-11 col-sm-11 pt-5 pb-10 pr-20 pl-15">
            <div className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
              <div className=" col-mb-12 col-xs-12 col-lg-12 col-sm-12  pl-0 pr-0">
                <InputField
                  {...{
                    formik,
                    title: 'Segment Name',
                    name: 'reportName',
                    value: DuolicatetData.filterName,
                  }}
                  style={{
                    backgroundColor: '#F3F6F9',
                    fontWeight: '500',
                    fontSize: '14px',
                    lineHeight: '150%',
                  }}
                  handleChange={(e) =>
                    setDuolicatetData({
                      ...DuolicatetData,
                      filterName: e.target.value,
                    })
                  }
                />
                {error ? <HintField error={error} /> : null}
              </div>
              <div className=" col-mb-6 col-xs-6 col-lg-6 col-sm-6  pl-0 pr-0 d-flex justify-content-between mx-auto pt-8">
                <CancelButton
                  onClick={() => closeDuplicateModal()}
                  type="button"
                  className={`btn font-weight-bold`}
                >
                  cancel
                </CancelButton>
                <CancelButton
                  type="button"
                  className="btn btn-primary font-weight-bold"
                  onClick={() => {
                    DuolicatetReport();
                  }}
                >
                  {/* {duolicatetIsLoading ? <CircularProgress /> : "Save"} */}
                  {duolicatetIsLoading ? (
                    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                      <Loader />
                    </div>
                  ) : (
                    'Save'
                  )}
                </CancelButton>
              </div>
            </div>
          </div>
        </ModalBox>
      </MyModal>
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseModal}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};
